// extracted by mini-css-extract-plugin
export default {"select":"Select_select__aeuTF","error":"Select_error__JRT9x"};